import React from 'react';
import { Flex, Text, Box } from '@makerdao/ui-components-core';

import { getWebClientProviderName } from 'utils/web3';
import { cutMiddle } from 'utils/ui';
import useLanguage from 'hooks/useLanguage';

import CaratDownIcon from 'components/Carat';

import config from '../references/config.json';
import 'hayker/css/change.css';
import { removeSpace } from 'utils/ui';

import 'bakerdao/css/pc/right/wallet.css'

const ActiveAccount = ({
  address,
  type,
  textColor = 'darkPurple',
  t = 'body',
  addressTextStyle = 'body',
  readOnly,
  ...rest
}) => {
  const { lang } = useLanguage();

  const defaultNetwork = config.defaultNetwork;
  // const defaultNetworkName = config.networkDisplayNames[defaultNetwork];
  let defaultNetworkName = '';
  if (defaultNetwork == '97') {
    defaultNetworkName = lang.test_network_name;
  } else {
    defaultNetworkName = lang.main_network_name;
  }

  console.log(defaultNetwork, 'defaultNetwork');

  let providerType =
    type === 'browser' ? getWebClientProviderName(type) : type;
  
  // 如果连接了币安，就显示币安钱包
  if (sessionStorage.getItem('hasConnected') == 'binance' && window.ethereum && window.ethereum.isMetaMask === undefined) {
    providerType = 'binance';
  }

  return (
    <Flex justifyContent="space-between" alignItems="center" {...rest}>
      <Text fontSize="0.8rem" color={address ? 'makerTeal' : 'makerOrange'}>
        ●
      </Text>
      {
        address ? (<span className="meta-mask" style={{ display: readOnly ? 'none' : 'inline-block' }}>{address ? defaultNetworkName : ''}</span>) : (null)
      }

      {/* <Box ml="xs" mr="auto"> */}
      <span
        t={t}
        color={textColor}
        fontSize="m"
        className="connect-net"
        style={{
          padding: lang.providers[providerType] || !address ? '5px 6px' : '0'
        }}
      >
        {address ? lang.providers[providerType] : lang.sidebar.no_wallet}
      </span>
      {/* </Box> */}
      <Box ml="s">
        {address ? (
          <Text t={addressTextStyle} color={textColor} fontSize="1.3rem">
            {cutMiddle(address, 7, 5)}
          </Text>
        ) : null}
      </Box>
      {readOnly ? null : (
        <Box ml="xs" mb="2px">
          <CaratDownIcon width="11px" height="6px" />
        </Box>
      )}
    </Flex>
  );
};

export default ActiveAccount;
